// extracted by mini-css-extract-plugin
export var card = "OfferCard-module--card--fa445";
export var copy = "OfferCard-module--copy--cecb1";
export var cta = "OfferCard-module--cta--497a0";
export var expiry = "OfferCard-module--expiry--da309";
export var image = "OfferCard-module--image--16b68";
export var imageWrapper = "OfferCard-module--imageWrapper--b4902";
export var mobileOnlyCta = "OfferCard-module--mobileOnlyCta--05e98";
export var spacer = "OfferCard-module--spacer--aefe7";
export var terms = "OfferCard-module--terms--da335";
export var title = "OfferCard-module--title--026ac";
export var wideCopy = "OfferCard-module--wideCopy--aa9e0";
export var wideCta = "OfferCard-module--wideCta--0925b";